(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3416],{

/***/ 48033:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/pdp",
      function () {
        return __webpack_require__(20504);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94020);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19514);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9473);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2595);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _hooks_usePageAuth__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48375);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55760);
/* harmony import */ var _components_ProductDetail_v3_productDetailsHelper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14887);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88751);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24899);
/* harmony import */ var _store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(44561);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(92058);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(10884);
/* harmony import */ var _components_ProductDetail_v3_ProductDetail__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4637);
/* harmony import */ var _components_PairsWellWith_PairsWellWith__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(32046);
/* harmony import */ var _components_ProductDetail_v3_ProductAccordion__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(30534);
/* harmony import */ var _components_Review_v1_Review__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(93330);
/* harmony import */ var _components_ProductDetail_v3_ProductLandingTeasers_ProductExf__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(97463);
/* harmony import */ var _components_ProductDetail_v3_PDPLoader__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(2535);
/* harmony import */ var _components_core_Head_NextHead__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(20812);
/* harmony import */ var _components_ProductDetail_v3_ProductDetailView_PDPCuratedProducts__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(25762);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _components_ImageGallery_v2_constants__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(75671);




























/**
 * renders ProductDetailsPage page
 * @return {JSX.Element}
 */ function ProductDetailsPage(param) {
    let { tmpData: data = {} , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analyticsData , gbhDataLayerCustom , slug , tmpSkuId: skuId , type , pdpData , apiStatus: status , apiStatusText: statusText , initialImgAlt , initialImgUrl , initialImageFullUrl , fullUrl , isPart , siteName , metaContent , seoProperties: { email ="" , phoneNum =""  } = {} , variantImages , reviewStatsData , fullReviewData  } = param;
    var ref, ref1;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_13__/* .selectAuthState */ ._9);
    const { pageIsInteractive  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .selectGenericState */ .Px);
    const { isTeaserLoaded , isProductExcludeFromPaidAdvertising  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_14__/* .selectPdpState */ .BY);
    const [pageRedirect, setPageRedirect] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const { redirectTarget: { page: { path =""  } = {}  } = {}  } = data;
    const [config, setConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [priceSpiderKey, setPriceSpiderKey] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [priceSpiderLanguage, setPriceSpiderLanguage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [priceSpiderCountry, setPriceSpiderCountry] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const { primaryBundleSKU_s: primaryBundleSKUs = "" , productRegionAllVariantDiscontinued_b: discontinuedProduct = false  } = pdpData;
    const isBundleProduct = Boolean(primaryBundleSKUs);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_5__/* .getConfig */ .i)().then((config)=>setConfig(config));
        scrollToTop();
        const { ProductLocalCategory_s: productLocalCategory = "" , Product_Category: productCategory = "" , CustomerFacingSKU_s: skuID = "" , CustomerFacingBrand_s: siteName = ""  } = pdpData;
        window.needPdpdata = {
            productSubCatergory: (productLocalCategory === null || productLocalCategory === void 0 ? void 0 : productLocalCategory.toLowerCase()) || (productCategory === null || productCategory === void 0 ? void 0 : productCategory.toLowerCase()),
            skuID,
            siteName: siteName.toLowerCase()
        };
        if (gbhDataLayerCustom) dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setGbhDataLayerCustom */ .ks)(gbhDataLayerCustom));
        return ()=>dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setGbhDataLayerCustom */ .ks)(""));
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        window.adobeTarget = window.adobeTarget || {};
        window.adobeTarget.pdp = {
            variantImages: variantImages
        };
    }, [
        variantImages
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(config)) {
            const psKey = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "general.priceSpiderKey", "");
            if (psKey) {
                setPriceSpiderKey(psKey);
            }
            const psLanguage = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "internationalization.language", "");
            if (psLanguage) {
                setPriceSpiderLanguage(psLanguage);
            }
            const psCountry = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "internationalization.country", "");
            if (psCountry) {
                setPriceSpiderCountry(psCountry);
            }
        }
    }, [
        config
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,_hooks_usePageAuth__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (analyticsData) (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .getDataLayerObj */ .C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    if ( true && ((ref = window.kohler) === null || ref === void 0 ? void 0 : (ref1 = ref.datalayer) === null || ref1 === void 0 ? void 0 : ref1.readyState) === "ready") {
        const kohlerDatalayer = window.kohler.datalayer;
        if (analyticsData && (kohlerDatalayer === null || kohlerDatalayer === void 0 ? void 0 : kohlerDatalayer.setItem)) {
            kohlerDatalayer.setItem("PAGE_INFO", analyticsData);
        }
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (path) {
            setPageRedirect((0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .removeAndCleanLink */ .xEh)(path));
        }
    }, [
        path
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isSsr && pageRedirect) {
            router.push(pageRedirect);
        }
    }, [
        isSsr,
        pageRedirect
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (pdpData && accessToken && pageIsInteractive && !isTeaserLoaded) {
            (0,_components_ProductDetail_v3_productDetailsHelper__WEBPACK_IMPORTED_MODULE_11__/* .getTeaserFragments */ .lX)(data, pdpData);
        }
    }, [
        accessToken,
        pdpData,
        pageIsInteractive,
        isTeaserLoaded
    ]);
    const scrollToTop = ()=>{
        window.scrollTo(0, 0);
    };
    const { language: metaLanguage = ""  } = data;
    const quickViewAuthData = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .getQuickViewAuth */ .sKe)(footer);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Head_NextHead__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                psKey: priceSpiderKey,
                psCountry: priceSpiderCountry,
                psLanguage: priceSpiderLanguage,
                fullUrl: fullUrl,
                metaLanguage: metaLanguage,
                pdpData: pdpData,
                reviewStatsData: reviewStatsData,
                fullReviewData: fullReviewData,
                isPart: isPart,
                initialImageFullUrl: initialImageFullUrl,
                skuId: skuId,
                siteName: siteName,
                isBundleProduct: isBundleProduct,
                persona: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .getUserPersona */ .shu)(),
                config: config,
                isProductExcludeFromPaidAdvertising: isProductExcludeFromPaidAdvertising
            }),
            header ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_15__["default"], {
                themeType: data === null || data === void 0 ? void 0 : data.appliedCssClassNames,
                header: header,
                title: pdpData === null || pdpData === void 0 ? void 0 : pdpData.metaTitle_s,
                description: pdpData === null || pdpData === void 0 ? void 0 : pdpData.metaDescription_s,
                templateName: data === null || data === void 0 ? void 0 : data.templateName,
                globalScripting: globalScript,
                isPdp: true,
                fullUrl: fullUrl,
                imageUrl: initialImageFullUrl,
                email: email,
                phone: phoneNum,
                siteName: siteName,
                data: data
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_25___default()), {
                id: "zoomdatapdp",
                src: "".concat(_components_ImageGallery_v2_constants__WEBPACK_IMPORTED_MODULE_26__/* .SCENE7_JS_URL */ .e5, "ZoomViewer.js")
            }, "zoomdatapdp"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_25___default()), {
                type: "text/javascript",
                src: "".concat(_components_ImageGallery_v2_constants__WEBPACK_IMPORTED_MODULE_26__/* .SCENE7_JS_URL */ .e5, "SpinViewer.js")
            }),
            data && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(pdpData) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "min-vh-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    data: data,
                    count: 0,
                    productDetail: (data, slug, skuId, type)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductDetail_v3_ProductDetail__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            data: data,
                            pdpData: pdpData,
                            slug: slug,
                            skuId: skuId,
                            type: type,
                            initialImgAlt: initialImgAlt,
                            initialImgUrl: initialImgUrl,
                            analyticsData: analyticsData
                        }),
                    productDetailFiller: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductDetail_v3_PDPLoader__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                            initialImgAlt: initialImgAlt,
                            initialImgUrl: initialImgUrl,
                            pdpJson: data,
                            pdpData: pdpData,
                            skuId: skuId
                        }),
                    pairsWellWith: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PairsWellWith_PairsWellWith__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            data: data,
                            skuId: skuId
                        }),
                    productAccordion: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductDetail_v3_ProductAccordion__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            data: data
                        }),
                    review: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Review_v1_Review__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            data: data
                        }),
                    productExf: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductDetail_v3_ProductLandingTeasers_ProductExf__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            data: data
                        }),
                    slug: slug,
                    skuId: skuId,
                    type: type,
                    pdpCuratedProduct: (data)=>!discontinuedProduct ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductDetail_v3_ProductDetailView_PDPCuratedProducts__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                            authData: data,
                            slug: slug,
                            skuId: skuId,
                            quickViewAuthData: quickViewAuthData
                        }) : null
                })
            }) : null,
            footer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_16__["default"], {
                footer: footer,
                footerScripting: footerScript
            }) : null
        ]
    });
}
ProductDetailsPage.propTypes = {
    reviewStatsData: (prop_types__WEBPACK_IMPORTED_MODULE_27___default().object),
    fullReviewData: (prop_types__WEBPACK_IMPORTED_MODULE_27___default().object)
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ProductDetailsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2374,3913,3147,6514,9747,3635,1045,9774,2888,179], function() { return __webpack_exec__(48033); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);